/* Everything Omer may change lives here. Live, prices and variant ids come from Shopify.
   "Buy 2, save 20%" runs as a Shopify automatic discount (20% off every console once there are two),
   shipping as a Shopify rate ($9, free from $100). */
const A = n => (window.P1_ASSETS || {})[n] || n;
const CONFIG = {
  preview: false,
  name: "ARKIO",
  currency: "$",
  price: 79,
  games: "20,000+",
  gamesN: 20000,
  /* storage per console: price = price + add. Live, add comes from the Shopify variant prices (option 2, "64 GB" / "128 GB").
     bar = lit blocks of 8 on the little LCD meter. */
  storage: [
    { id: "64",  name: "64 GB",  games: "20,000+", gamesN: 20000, add: 0,  bar: 4 },
    { id: "128", name: "128 GB", games: "40,000+", gamesN: 40000, add: 10, bar: 8, tag: "Best value" }
  ],
  bundles: [
    { qty: 1, badge: "1P", name: "Solo", meta: "1 console" },
    { qty: 2, badge: "2P", name: "Duo",  meta: "20% off both", offPct: 20 }
  ],
  shipping: { fee: 9, freeFrom: 100 },
  colours: [
    { id: "grape",    name: "Grape",    swatch: "linear-gradient(145deg,#B9A6F6 0%,#7A5BE0 50%,#4E31B5 100%)", photo: A("studio-grape.webp"),    thumb: A("studio-grape-thumb.webp"),    cut: A("cut-grape.webp") },
    { id: "midnight", name: "Midnight", swatch: "linear-gradient(145deg,#6A6774 0%,#2B2931 55%,#141318 100%)", photo: A("studio-midnight.webp"), thumb: A("studio-midnight-thumb.webp"), cut: A("cut-midnight.webp") },
    { id: "chalk",    name: "Chalk",    swatch: "linear-gradient(145deg,#FFFFFF 0%,#F1EFEA 55%,#DCD8D0 100%)", photo: A("studio-chalk.webp"),    thumb: A("studio-chalk-thumb.webp"),    cut: A("cut-chalk.webp") }
  ],
  deliveryDays: [4, 12],
  warrantyMonths: 2,
  battery: "up to 10 hours",
  variantIds: {},
  /* add-ons: the popup offers case + glass, the cart also offers the grip. "two" is the price for 2 consoles' worth.
     Live, ids and prices come from the Shopify products with these handles. */
  addons: [
    { id: "case", handle: "arkio-travel-case", img: A("acc-case.webp"),
      one: { label: "1 case", title: "Travel case", line: "Hard shell, zips shut", price: 19 },
      two: { label: "2 cases", title: "2 travel cases", line: "One for each console", price: 29 } },
    { id: "glass", handle: "arkio-screen-protector", img: A("acc-glass.webp"),
      one: { label: "1 pack", title: "Screen protector", line: "3 tempered-glass sheets", price: 15 },
      two: { label: "2 packs", title: "2 screen protector packs", line: "3 sheets for each console", price: 25 } },
    { id: "grip", handle: "arkio-pro-grip", img: A("acc-grip.webp"), cartOnly: true,
      one: { label: "1 grip", title: "Pro grip", line: "Full-size handles", price: 25 } }
  ]
};

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const round2 = n => Math.round(n * 100) / 100;
const money = n => CONFIG.currency + (Math.abs(n - Math.round(n)) < .005 ? Math.round(n) : n.toFixed(2));
const gbId = o => String(parseInt(o, 10) || 64);              // "128 GB" -> "128"; no storage option -> "64"
const state = { qty: 1, colours: ["grape", "chalk"], storage: ["64", "64"], cart: [] };
/* live product data from Shopify: option 1 = colour, option 2 = storage ("64 GB" / "128 GB") */
if (window.P1_PRODUCT) {
  const P = window.P1_PRODUCT; CONFIG.price = P.price / 100;
  P.variants.forEach(v => { const c = String(v.option1).toLowerCase(); CONFIG.variantIds[`${c}|${gbId(v.option2)}`] = v.id; if (!CONFIG.variantIds[c]) CONFIG.variantIds[c] = v.id; });
  CONFIG.storage.forEach(s => { const ps = P.variants.filter(v => gbId(v.option2) === s.id).map(v => v.price / 100); if (ps.length) s.add = Math.min(...ps) - CONFIG.price; else s.off = true; });
}

/* plain facts into the copy */
const facts = {
  warranty: `${CONFIG.warrantyMonths}-month`, warrantyCap: `${CONFIG.warrantyMonths}-month`, warrantyLong: `${CONFIG.warrantyMonths} months`,
  battery: CONFIG.battery, games: CONFIG.games,
  delivery: CONFIG.deliveryDays.join("–")
};
$$("[data-k]").forEach(el => { if (facts[el.dataset.k] != null) el.textContent = facts[el.dataset.k]; });

/* delivery estimate in business days */
function addBiz(d, n) { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w && w !== 6) n--; } return x; }
const fmt = d => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
const now = new Date();
$("#eta-ordered").textContent = fmt(now);
$("#eta-delivered").textContent = `${fmt(addBiz(now, CONFIG.deliveryDays[0]))} – ${fmt(addBiz(now, CONFIG.deliveryDays[1]))}`;

/* ---------- options ---------- */
const bundle = (q = state.qty) => CONFIG.bundles.find(b => b.qty === q);
const colour = id => CONFIG.colours.find(c => c.id === id);
const gbs = () => CONFIG.storage.filter(s => !s.off);
const gb = id => gbs().find(s => s.id === id) || gbs()[0];
const unitOf = i => CONFIG.price + gb(state.storage[i]).add;
function priceFor(q) {
  const b = bundle(q), units = Array.from({ length: q }, (_, i) => unitOf(i)), full = round2(units.reduce((s, u) => s + u, 0));
  /* like the Shopify discount: the % comes off every console */
  const save = b.offPct ? round2(full * b.offPct / 100) : 0;
  return { full, save, total: round2(full - save) };
}
const consoleMeta = (name, sid) => { const s = gb(sid); return gbs().length > 1 ? `${name} · ${s.name} · ${s.games} games` : `${name} · ${s.games} games`; };

const headBits = b => { const p = priceFor(b.qty); return `
        <span><span class="c-name">${b.name}</span><br><span class="c-meta">${b.meta}${p.save ? ` · <span class="c-save">save ${money(p.save)}</span>` : ""}</span></span>
        <span class="c-right"><span class="c-price">${money(p.total)}</span>${p.save ? `<s>${money(p.full)}</s>` : ""}</span>`; };
function renderBundles() {
  $("#bundles").innerHTML = CONFIG.bundles.map(b => `<div class="choice">
      <label class="c-head">
        <input type="radio" name="bundle" value="${b.qty}" ${b.qty === state.qty ? "checked" : ""}>
        ${b.offPct ? `<span class="c-tag px">Save ${b.offPct}%</span>` : ""}
        <span class="p-badge" aria-hidden="true">${b.badge}</span>
        <span class="c-dyn" data-q="${b.qty}">${headBits(b)}</span>
      </label>
      <div class="c-colours" data-q="${b.qty}"></div>
    </div>`).join("");
}
/* bundle prices follow the storage picks, updated in place so the radios keep focus */
function renderHeads() { $$("#bundles .c-dyn").forEach(el => { el.innerHTML = headBits(bundle(+el.dataset.q)); }); }
const gbButton = (s, i) => `<button type="button" class="gb-o" data-i="${i}" data-s="${s.id}" aria-pressed="${gb(state.storage[i]) === s}">
          ${s.tag ? `<span class="gb-tag px">${s.tag}</span>` : ""}<span class="gb-top"><b>${s.name}</b>${s.add > 0 ? `<span class="gb-add">+${money(s.add)}</span>` : ""}</span>
          <span class="gb-games"><strong>${s.games}</strong> games</span>
          <span class="gb-bar" aria-hidden="true">${Array.from({ length: 8 }, (_, k) => `<i${k < s.bar ? ' class="on"' : ""}></i>`).join("")}</span></button>`;
/* the colour + storage pickers sit inside the chosen bundle box: one row per console, so 2P can mix */
function renderSwatches() {
  $$(".c-colours").forEach(el => {
    const q = +el.dataset.q;
    el.innerHTML = q !== state.qty ? "" : Array.from({ length: q }, (_, i) => {
      const cur = colour(state.colours[i]);
      return `<div class="cc-row"><img src="${cur.cut}" alt="">
        <span class="lbl">${q > 1 ? `Console ${i + 1}` : "Colour"}<b>${cur.name}</b></span>
        <div class="swatches" role="group" aria-label="${q > 1 ? `Colour for console ${i + 1}` : "Colour"}">${CONFIG.colours.map(c =>
          `<button type="button" class="sw" style="--c:${c.swatch}" data-i="${i}" data-c="${c.id}" aria-pressed="${state.colours[i] === c.id}" aria-label="${c.name}" title="${c.name}"></button>`).join("")}</div>
        ${gbs().length > 1 ? `<div class="gb" role="group" aria-label="${q > 1 ? `Storage for console ${i + 1}` : "Storage"}">${gbs().map(s => gbButton(s, i)).join("")}</div>` : ""}</div>`;
    }).join("");
  });
}
function renderPrice() {
  const p = priceFor(state.qty), b = bundle();
  renderHeads();
  $("#price").textContent = money(p.total);
  const was = $("#price-was"); was.hidden = !p.save; was.textContent = money(p.full);
  const perGame = unitOf(0) * 100 / gb(state.storage[0]).gamesN;
  $("#price-note").innerHTML = state.qty > 1
    ? `2 consoles, <b>${b.offPct}% off both</b>${p.total >= CONFIG.shipping.freeFrom ? ", and shipping is free" : ""}.`
    : `One payment. That's <b>${perGame < .5 ? "less than half a cent" : "about " + perGame.toFixed(1) + "¢"} a game</b>.`;
  $("#add-label").textContent = `${state.qty > 1 ? `Add ${state.qty} to cart` : "Add to cart"} · ${money(p.total)}`;
  $("#cont-label").textContent = `Get yours · ${money(p.total)}`;
  $("#sticky-name").textContent = `${CONFIG.name}${state.qty > 1 ? " × 2" : ""}`;
  $("#sticky-price").textContent = `${money(p.total)}${p.total >= CONFIG.shipping.freeFrom ? " · free shipping" : ""}`;
  $("#sticky-img").src = colour(state.colours[0]).cut;
}
function setHero(id) {
  const c = colour(id), img = $("#hero-img");
  img.style.opacity = 0;
  setTimeout(() => { img.src = c.photo; img.alt = `${CONFIG.name} handheld in ${c.name}`; img.style.opacity = 1; }, 140);
  $("#thumb-hero").src = c.thumb;
}

$("#bundles").addEventListener("change", e => { state.qty = +e.target.value; renderSwatches(); renderPrice(); });
$("#bundles").addEventListener("click", e => {
  const g = e.target.closest(".gb-o");
  if (g) {
    state.storage[+g.dataset.i] = g.dataset.s;
    $$(".gb-o", g.parentNode).forEach(x => x.setAttribute("aria-pressed", x === g));
    renderPrice(); return;
  }
  const b = e.target.closest(".sw"); if (!b) return;
  const { i, c } = b.dataset, row = b.closest(".cc-row");
  state.colours[+i] = c;
  /* update the row in place so focus stays put and the row doesn't replay its entrance */
  $("img", row).src = colour(c).cut; $(".lbl b", row).textContent = colour(c).name;
  $$(".sw", row).forEach(s => s.setAttribute("aria-pressed", s === b));
  renderPrice(); setHero(c); goTo(0);
});
renderBundles(); renderSwatches(); renderPrice();

/* ---------- gallery ---------- */
const track = $("#gal-track"), slides = $$(".slide", track), thumbs = $$("#thumbs button");
let cur = 0;
function goTo(i) { cur = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: cur * track.clientWidth, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); }
thumbs.forEach((t, i) => t.addEventListener("click", () => goTo(i)));
$("#gal-prev").addEventListener("click", () => goTo(cur - 1));
$("#gal-next").addEventListener("click", () => goTo(cur + 1));
track.addEventListener("scroll", () => {
  const i = Math.round(track.scrollLeft / track.clientWidth); if (i === cur && thumbs[i]?.getAttribute("aria-current") === "true") return;
  cur = i; thumbs.forEach((t, k) => t.setAttribute("aria-current", k === i)); $("#gal-count").textContent = `${i + 1} / ${slides.length}`;
  $("#gal-badge").classList.toggle("off", !!$(".cap", slides[i]));
  const v = $("video", slides[1]); if (i === 1) v.play().catch(() => {}); else v.pause();
}, { passive: true });
track.addEventListener("keydown", e => { if (e.key === "ArrowRight") goTo(cur + 1); if (e.key === "ArrowLeft") goTo(cur - 1); });
thumbs[0].setAttribute("aria-current", "true");
$("#gal-count").textContent = `1 / ${slides.length}`;

/* section videos play only while on screen */
const vio = new IntersectionObserver(es => es.forEach(en => { const v = en.target; if (en.isIntersecting) { if (v.preload === "none") v.preload = "auto"; v.play().catch(() => {}); } else v.pause(); }), { threshold: .25 });
$$("video[data-auto]").forEach(v => vio.observe(v));

/* sticky bar appears once the main button scrolls away */
const sticky = $("#sticky");
new IntersectionObserver(([en]) => {
  const show = !en.isIntersecting && en.boundingClientRect.top < 0;
  sticky.classList.toggle("show", show); sticky.setAttribute("aria-hidden", !show); $("#sticky-btn").tabIndex = show ? 0 : -1;
}).observe($("#add"));

/* ---------- add-ons, protect popup, cart drawer ---------- */
const LIVE = !CONFIG.preview;
const CONSOLE = (window.P1_PRODUCT && window.P1_PRODUCT.handle) || "arkio-retro-console";
if (window.P1_ADDONS) CONFIG.addons.forEach(a => {
  const p = window.P1_ADDONS[a.handle];
  if (!p || !p.variants) { a.off = true; return; }
  ["one", "two"].forEach((k, i) => { const v = p.variants[i]; if (a[k] && v) { a[k].id = v.id; a[k].price = v.price / 100; } else if (a[k]) delete a[k]; });
});
const addon = id => CONFIG.addons.find(a => a.id === id);
const addonByHandle = h => CONFIG.addons.find(a => a.handle === h);
const packKey = n => n > 1 ? "two" : "one";
const packFor = (a, n) => a[packKey(n)] || a.one;            // 2 consoles -> the 2-pack, where there is one
const drawer = $("#drawer"), scrim = $("#scrim"), pop = $("#pop");
const mock = [];                                             // preview cart lines
let cart = { lines: [], total: 0, saved: 0 };

async function api(path, body) {
  const r = await fetch(path, body
    ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
    : { headers: { Accept: "application/json" }, cache: "no-store" });
  if (!r.ok) throw new Error(`${path} ${r.status}`);
  return r.json();
}
/* d = { kind: "console", colour, storage } | { kind: addon id, pack: "one" | "two" } | { id } */
const idOf = d => d.id || (d.kind === "console" ? CONFIG.variantIds[`${d.colour}|${d.storage}`] || CONFIG.variantIds[d.colour] : addon(d.kind)[d.pack].id);
async function cartAdd(ds) {
  if (LIVE) { await api("/cart/add.js", { items: ds.map(d => ({ id: idOf(d), quantity: d.qty || 1 })) }); return; }
  ds.filter(d => d.kind).forEach(d => {
    const key = `${d.kind}:${d.colour ? `${d.colour}|${d.storage}` : d.pack}`, l = mock.find(x => x.key === key), a = addon(d.kind);
    if (l) l.qty += d.qty || 1;
    else mock.push({ key, kind: d.kind, colour: d.colour, storage: d.storage, qty: d.qty || 1,
      unit: a ? a[d.pack].price : CONFIG.price + gb(d.storage).add, label: a ? a[d.pack].label : "" });
  });
}
async function cartChange(key, qty) {
  if (LIVE) { await api("/cart/change.js", { id: key, quantity: qty }); return; }
  const i = mock.findIndex(x => x.key === key);
  if (i > -1) { if (qty > 0) mock[i].qty = qty; else mock.splice(i, 1); }
}
function fromShopify(c) {
  const rank = l => l.kind === "console" ? 0 : l.kind === "other" ? 2 : 1;   // consoles first, then add-ons, oldest first
  return { total: c.total_price / 100, saved: c.total_discount / 100, lines: c.items.slice().reverse().map(it => {
    const opts = it.variant_options || [], a = addonByHandle(it.handle);
    const isC = it.handle === CONSOLE, col = isC && colour(String(opts[0] || it.variant_title).toLowerCase());
    const pack = a && (a.two && a.two.id === it.variant_id ? a.two : a.one);
    const off = (it.line_level_discount_allocations || []).find(x => x.amount > 0);
    return { key: it.key, qty: it.quantity, kind: isC ? "console" : a ? a.id : "other",
      img: col ? col.cut : a ? a.img : (it.image || ""),
      title: isC ? CONFIG.name : a ? pack.title : it.product_title,
      meta: isC ? consoleMeta(col ? col.name : opts[0], gbId(opts[1])) : a ? pack.line : (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : ""),
      tag: off ? `Buy 2, save ${bundle(2).offPct}%` : "",
      price: it.final_line_price / 100, was: it.original_line_price > it.final_line_price ? it.original_line_price / 100 : 0 };
  }).sort((a, b) => rank(a) - rank(b)) };
}
function fromMock() {
  /* same rule as the Shopify discount: once there are two consoles, every console is 20% off */
  const n = mock.filter(l => l.kind === "console").reduce((s, l) => s + l.qty, 0), pct = n >= 2 ? bundle(2).offPct : 0;
  let saved = 0;
  const lines = mock.map(l => {
    const full = round2(l.unit * l.qty), a = addon(l.kind), col = l.kind === "console" && colour(l.colour), cut = col ? round2(full * pct / 100) : 0;
    const pack = a && (a.two && a.two.label === l.label ? a.two : a.one);
    saved += cut;
    return { key: l.key, qty: l.qty, kind: l.kind, img: col ? col.cut : a.img, title: col ? CONFIG.name : pack.title,
      meta: col ? consoleMeta(col.name, l.storage) : pack.line, tag: cut ? `Buy 2, save ${pct}%` : "",
      price: round2(full - cut), was: cut ? full : 0 };
  });
  return { lines, saved: round2(saved), total: round2(lines.reduce((s, l) => s + l.price, 0)) };
}
async function refreshCart() {
  cart = LIVE ? fromShopify(await api("/cart.js")) : fromMock();
  renderCart();
  const count = cart.lines.reduce((s, l) => s + l.qty, 0);
  /* keep the store header's cart bubble in step */
  const icon = document.querySelector("cart-icon");
  if (icon && typeof icon.renderCartBubble === "function") icon.renderCartBubble(count);
}
const consolesIn = () => cart.lines.filter(l => l.kind === "console").reduce((s, l) => s + l.qty, 0);
function renderCart() {
  const consoles = consolesIn(), count = cart.lines.reduce((s, l) => s + l.qty, 0);
  $("#d-count").textContent = count || "";
  $("#lines").innerHTML = cart.lines.map(l => `
    <div class="line" data-key="${l.key}">
      <span class="l-img${l.kind === "console" ? " tall" : ""}"><img src="${l.img}" alt=""></span>
      <div class="l-mid"><b>${l.title}</b>${l.meta ? `<small>${l.meta}</small>` : ""}${l.tag ? `<span class="l-tag">${l.tag}</span>` : ""}
        <div class="qty" role="group" aria-label="Quantity of ${l.title}"><button type="button" data-q="${l.qty - 1}" aria-label="One less">−</button><span>${l.qty}</span><button type="button" data-q="${l.qty + 1}" aria-label="One more">+</button></div>
      </div>
      <div class="l-end"><span><span class="l-price">${money(l.price)}</span>${l.was ? `<br><s>${money(l.was)}</s>` : ""}</span><button type="button" class="l-rm" data-q="0">Remove</button></div>
    </div>`).join("")
    || `<div class="d-empty"><p>Your cart is empty.</p><button class="btn" type="button" id="d-shop">Get yours · ${money(CONFIG.price)} <span class="arrow" aria-hidden="true">▶</span></button></div>`;
  const ups = consoles ? CONFIG.addons.filter(a => !a.off && !cart.lines.some(l => l.kind === a.id)) : [];
  $("#ups").hidden = !ups.length;
  $("#ups-row").innerHTML = ups.map(a => { const p = packFor(a, consoles); return `
    <div class="up"><span class="up-img"><img src="${a.img}" alt=""></span><span class="up-t"><b>${p.title}</b><small>${money(p.price)} · ${p.line}</small></span>
      <button type="button" class="up-add" data-a="${a.id}" data-p="${p === a.two ? "two" : "one"}" aria-label="Add ${p.title}">+ Add</button></div>`; }).join("");
  $("#d-save").hidden = !cart.saved; $("#d-save-v").textContent = `−${money(cart.saved)}`;
  /* shipping: $9, free from $100 (the same rate Shopify charges at checkout) */
  const S = CONFIG.shipping, free = cart.total >= S.freeFrom, ship = count && !free ? S.fee : 0, total = round2(cart.total + ship);
  $("#d-ship").hidden = !count; $("#d-ship").classList.toggle("done", free);
  $("#ship-msg").innerHTML = free ? `<b>Free shipping</b> unlocked on this order` : `You're <b>${money(round2(S.freeFrom - cart.total))}</b> away from <b>free shipping</b>`;
  $("#ship-fill").style.width = `${Math.min(100, cart.total / S.freeFrom * 100)}%`;
  $("#d-ship-row").hidden = !count; $("#d-ship-row").classList.toggle("free", free); $("#d-ship-v").textContent = free ? "Free" : money(S.fee);
  $("#drawer-total").textContent = money(total);
  $("#checkout-label").textContent = count ? `Checkout · ${money(total)}` : "Checkout";
  $("#checkout").disabled = !count;
}
async function busy(fn) {
  drawer.classList.add("busy");
  try { await fn(); } catch (err) { console.warn(err); }
  try { await refreshCart(); } catch (err) { console.warn(err); }
  drawer.classList.remove("busy");
}

let lastFocus = null;
function lockPage(on) { document.documentElement.style.overflow = on ? "hidden" : ""; }
function showScrim(on) { scrim.classList.toggle("show", on); }
function openCart(o) {
  if (o) { lastFocus = lastFocus || document.activeElement; closePop(false); }
  drawer.classList.toggle("show", o); drawer.setAttribute("aria-hidden", !o); showScrim(o); lockPage(o);
  if (o) $("#drawer-close").focus(); else if (lastFocus) { lastFocus.focus?.(); lastFocus = null; }
}

/* popup: what to offer depends on how many consoles were just added */
let popQty = 1;
function popSelected() { return $$(".po[aria-pressed='true']", pop).map(b => ({ kind: b.dataset.a, pack: b.dataset.p })); }
function popLabel() {
  const sum = round2(popSelected().reduce((s, d) => s + addon(d.kind)[d.pack].price, 0));
  $("#pop-add-label").textContent = sum ? `Add to order · ${money(sum)}` : "Continue to cart";
}
function openPop(q) {
  popQty = q;
  $("#pop-added").textContent = q > 1 ? `${q} consoles added` : "Added to cart";
  const opts = CONFIG.addons.filter(a => !a.cartOnly && !a.off && !cart.lines.some(l => l.kind === a.id));
  if (!opts.length) { openCart(true); return; }
  $("#pop-opts").innerHTML = opts.map(a => {
    const k = packKey(q), p = a[k] || a.one, save = p === a.two ? round2(a.one.price * 2 - p.price) : 0;
    return `<button type="button" class="po" data-a="${a.id}" data-p="${p === a.two ? "two" : "one"}" aria-pressed="false">
      <span class="po-img"><img src="${a.img}" alt=""></span>
      <span class="po-t"><b>${p.title}</b><small>${p.line}</small></span>
      <span class="po-p"><b>${money(p.price)}</b>${save > 0 ? `<small>save ${money(save)}</small>` : ""}</span>
      <span class="po-c" aria-hidden="true"><svg class="icon"><use href="#i-check"/></svg></span></button>`;
  }).join("");
  popLabel();
  lastFocus = document.activeElement;
  pop.setAttribute("aria-hidden", "false"); showScrim(true); lockPage(true);
  void pop.offsetWidth; pop.classList.add("show");          // reflow first so the sheet slides in
  setTimeout(() => $(".po", pop)?.focus(), 60);
}
function closePop(toCart) {
  if (!pop.classList.contains("show")) return;
  pop.classList.remove("show"); pop.setAttribute("aria-hidden", "true");
  if (toCart) openCart(true); else { showScrim(false); lockPage(false); }
}
$("#pop-opts").addEventListener("click", e => {
  const b = e.target.closest(".po"); if (!b) return;
  b.setAttribute("aria-pressed", b.getAttribute("aria-pressed") !== "true"); popLabel();
});
$("#pop-add").addEventListener("click", async () => {
  const sel = popSelected();
  closePop(true);
  if (sel.length) await busy(() => cartAdd(sel));
});
$("#pop-skip").addEventListener("click", () => closePop(true));
$("#pop-x").addEventListener("click", () => closePop(true));

async function addToCart() {
  const b = bundle(), ds = [];
  state.colours.slice(0, state.qty).forEach((c, i) => {
    const s = gb(state.storage[i]).id, d = ds.find(x => x.colour === c && x.storage === s);
    if (d) d.qty++; else ds.push({ kind: "console", colour: c, storage: s, qty: 1 });
  });
  try { await cartAdd(ds); } catch (err) { console.warn(err); }
  try { await refreshCart(); } catch (err) { console.warn(err); }
  openPop(state.qty);
}
["#add", "#sticky-btn", "#cont-btn"].forEach(s => $(s).addEventListener("click", addToCart));

$("#lines").addEventListener("click", e => {
  const b = e.target.closest("[data-q]"); if (b) { const key = b.closest(".line").dataset.key; busy(() => cartChange(key, Math.max(0, +b.dataset.q))); return; }
  if (e.target.closest("#d-shop")) { openCart(false); $("#buy").scrollIntoView({ behavior: "smooth" }); }
});
$("#ups-row").addEventListener("click", e => {
  const b = e.target.closest(".up-add"); if (b) busy(() => cartAdd([{ kind: b.dataset.a, pack: b.dataset.p }]));
});
$("#drawer-close").addEventListener("click", () => openCart(false));
scrim.addEventListener("click", () => { if (pop.classList.contains("show")) closePop(true); else openCart(false); });
document.addEventListener("keydown", e => {
  if (e.key !== "Escape") return;
  if (pop.classList.contains("show")) closePop(true); else if (drawer.classList.contains("show")) openCart(false);
});
$("#checkout").addEventListener("click", () => { if (LIVE) location.href = "/checkout"; });

/* the cart icon in the store header opens this drawer instead of the theme's own cart */
function openFromHeader(e) {
  e.preventDefault(); e.stopImmediatePropagation();
  refreshCart().catch(err => console.warn(err)); openCart(true);
}
window.addEventListener("click", e => {
  if (e.target.closest('#header-component [on\\:click*="cart-drawer"], #header-component a[href$="/cart"], #mock-cart')) openFromHeader(e);
}, true);
if (LIVE) refreshCart().catch(() => {});

/* ---------- policies: real Shopify pages live, a preview dialog here ---------- */
const dlg = $("#policy");
$$("[data-policy]").forEach(a => a.addEventListener("click", e => {
  if (!CONFIG.preview) return;
  e.preventDefault();
  $$(".pol", dlg).forEach(p => p.hidden = p.dataset.pol !== a.dataset.policy);
  dlg.showModal();
}));
if (dlg) $("#policy-close").addEventListener("click", () => dlg.close());

/* ---------- continue screen ---------- */
const digit = $("#digit"); let dn = 9;
if (!matchMedia("(prefers-reduced-motion: reduce)").matches) setInterval(() => { dn = dn === 0 ? 9 : dn - 1; digit.textContent = dn; }, 1000);
